import styles from './styles.module.scss';
import HomeGamesCarousel from './Carousel';
import { sectionsRefer } from '@/enums/sectionsRefer';
import useTranslation from 'next-translate/useTranslation';
import { Animation } from '@starsoft/common/components';

export default function HomeGamesSections() {
  const { t } = useTranslation('common');

  return (
    <div id={sectionsRefer.projects}>
      <div className={styles.container}>
        <div className={styles.container__title}>
          <Animation type="fadeInDown">
            <h2>{t('games__heading')}</h2>
          </Animation>
        </div>
        <div className={styles.container__description}>
          <Animation type="fadeInRight">{t('games__description')}</Animation>
        </div>
      </div>
      <HomeGamesCarousel />
    </div>
  );
}
